import {Col, Row} from "antd";
import React, {useEffect} from "react";
import {useCourierWalletInvoiceSubTab} from "./useCourierWalletInvoiceSubTab";
import {CourierWalletInvoicesList} from "./courierWalletInvoicesList/CourierWalletInvoicesList";
import {CourierWalletInvoiceDetail} from "./courierWalletInvoiceDetail/CourierWalletInvoiceDetail";
import moment from "moment";
import {useStore} from "@vigo/hooks";

export const CourierWalletInvoiceSubTab = ({
    courier,
    canRender = false,
    walletStartDate,
    walletStartDateRecall,
    selectedDateRange,
    onDateRangeChange
}) => {
    const stores = useStore();
    const isAgency = stores.meStore.checkRole("isAgency");
    const {
        paymentInvoicesResultLoading,
        paymentInvoices,
        selectedPaymentInvoice,
        handlePaymentInvoiceSelect
    } = useCourierWalletInvoiceSubTab({courier, canRender, selectedDateRange, onDateRangeChange});

    useEffect(() => {
        if (canRender && walletStartDateRecall && onDateRangeChange) {
            onDateRangeChange([moment(walletStartDate), selectedDateRange?.[1]]);
        }
    }, [walletStartDateRecall]);
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={isAgency ? 24 : 8}>
                <CourierWalletInvoicesList
                    paymentInvoices={paymentInvoices}
                    onItemSelect={handlePaymentInvoiceSelect}
                    selectedItem={selectedPaymentInvoice}
                    selectedDateRange={selectedDateRange}
                    onDateRangeChange={onDateRangeChange}
                    loading={paymentInvoicesResultLoading}
                />
            </Col>
            {!isAgency && (
                <Col xs={24} sm={24} md={24} lg={24} xl={16}>
                    {selectedPaymentInvoice && (
                        <CourierWalletInvoiceDetail
                            paymentInvoice={selectedPaymentInvoice}
                            loading={paymentInvoicesResultLoading}
                        />
                    )}
                </Col>
            )}
        </Row>
    );
};
